var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTotalActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#6B5CE8"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13997_57170)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.3555 6.52578C10.2352 6.64063 9.17344 7.08125 8.27344 7.80547C8.01797 8.00938 7.57969 8.44766 7.37578 8.70313C6.83672 9.37344 6.42188 10.182 6.19922 10.9883C6.03984 11.5695 6.01172 11.8039 6.01172 12.5352C6.01172 13.2359 6.02813 13.3766 6.15703 13.8945C6.29766 14.4664 6.40078 14.6773 6.56016 14.7219C6.59297 14.7313 7.02656 14.7383 7.52344 14.7383C8.35781 14.7383 8.43047 14.7359 8.49609 14.6961C8.62031 14.6188 8.66016 14.5438 8.66016 14.3867C8.65781 14.2695 8.63906 14.2016 8.53828 13.9766C8.29922 13.4445 8.2125 12.9969 8.23359 12.4063C8.27109 11.4031 8.68359 10.4844 9.4125 9.77891C9.64688 9.55391 9.82734 9.41328 10.0664 9.26563C11.1656 8.59063 12.6047 8.55078 13.7578 9.1625C14.5031 9.55859 15.1477 10.2875 15.4758 11.1055C15.8859 12.132 15.8602 13.1844 15.3984 14.1289C15.2742 14.3844 15.157 14.5742 15.0023 14.7688L14.9016 14.893L14.6086 14.5859C14.4445 14.4172 14.2688 14.2531 14.2148 14.2203C14.025 14.1102 13.8 14.1664 13.7039 14.3516C13.6547 14.45 12.9141 18.0148 12.9141 18.1555C12.9141 18.2117 12.9328 18.2867 12.9609 18.3289C13.0102 18.4109 13.1602 18.5 13.2492 18.5C13.3289 18.5 17.0109 17.7313 17.0602 17.7031C17.1352 17.6633 17.2195 17.5461 17.2359 17.4594C17.2688 17.2883 17.2289 17.2227 16.8516 16.8477C16.6594 16.6555 16.5 16.4914 16.5 16.4844C16.5 16.4773 16.5656 16.3859 16.6453 16.2852C17.3531 15.3664 17.8219 14.2625 17.9648 13.1727C18.0117 12.8094 18.0117 12.0969 17.9648 11.7336C17.8195 10.6297 17.3906 9.62656 16.6898 8.75469C16.4508 8.45938 15.9398 7.9625 15.6516 7.74688C14.8031 7.11172 13.882 6.72969 12.8156 6.56797C12.4523 6.51406 11.6813 6.49063 11.3555 6.52578Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13997_57170"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(6 6.5)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTotalActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/total_active.db7e5ed85fe8c73845cb0b838bc59405.svg";